import { AbstractControl, FormArray, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { isCNPJ, isCPF } from '../validators';

export class GenericValidator {

	constructor() { }

	/**
	 * Valida se o CPF é valido. Deve-se ser informado o cpf sem máscara.
	*/
	static isValidCpf() {
		return (control: AbstractControl): Validators => {
			if (control.value) {
				if (!isCPF(control.value)) {
					return { cpfNotValid: true };
				}
			}
			return null;
		};
	}


	/**
		* Valida se o CNPJ é valido. Deve-se ser informado o cnpj sem máscara.
	*/
	static isValidCnpj() {
		return (control: AbstractControl): Validators => {
			if (control.value) {
				if (!isCNPJ(control.value)) {
					return { cnpjNotValid: true };
				}
			}
			return null;
		};
	}

	static isValidInfosInputValue(): ValidatorFn {
		return (formArray: FormArray): { [key: string]: any } | null => {
			const valid = formArray.controls.find((x: FormGroup) => x.value.checked && (x.value.description || '').length > 0);
			return valid ? null : { error: 'Tipo de Entrada obrigatório.' };
		};
	}

	static matchOtherValidator(otherControlName: string) {

		let thisControl: FormControl;
		let otherControl: FormControl;

		return function matchOtherValidate(control: FormControl) {
			if (!control.parent) {
				return null;
			}
			// Initializing the validator.
			if (!thisControl) {
				thisControl = control;
				otherControl = control.parent.get(otherControlName) as FormControl;
				if (!otherControl) {
					throw new Error('matchOtherValidator(): other control is not found in parent group');
				}
				otherControl.valueChanges.subscribe(() => {
					thisControl.updateValueAndValidity();
				});
			}

			if (!otherControl) {
				return null;
			}

			if (otherControl.value !== thisControl.value) {
				return { matchOther: true };
			}
			return null;
		};
	}

}
